import { useState } from "react";

import { Link } from "./Link";

/** Non-secret: remembers which session dismissed the warning. */
const SESSION_STORAGE_KEY = "canvaschool.initialPasswordWarningDismissed";
/** Non-secret: remembers which account chose to never see the warning again. */
const PERMANENT_STORAGE_KEY =
  "canvaschool.initialPasswordWarningDismissedForever";

const dismissedSessionId = (): string | null => {
  try {
    return window.sessionStorage.getItem(SESSION_STORAGE_KEY);
  } catch {
    return null;
  }
};

const isDismissedForever = (userId: string): boolean => {
  try {
    return window.localStorage.getItem(PERMANENT_STORAGE_KEY) === userId;
  } catch {
    return false;
  }
};

export const InitialPasswordWarning = ({
  sessionId,
  userId,
}: {
  sessionId: string;
  userId: string;
}) => {
  const [dismissed, setDismissed] = useState(
    () => dismissedSessionId() === sessionId || isDismissedForever(userId),
  );
  if (dismissed) {
    return null;
  }
  return (
    <div className="canvaschool-warning" role="note">
      <div className="canvaschool-warning-inner">
        <p>초기 비밀번호를 사용하고 있습니다. 비밀번호를 바꿔 주세요.</p>
        <Link to="/password">비밀번호 변경하기</Link>
        <button
          type="button"
          onClick={() => {
            try {
              window.sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId);
            } catch {
              // Dismissal still applies until this page is reloaded.
            }
            setDismissed(true);
          }}
        >
          경고 닫기
        </button>
        <button
          type="button"
          onClick={() => {
            try {
              window.localStorage.setItem(PERMANENT_STORAGE_KEY, userId);
            } catch {
              // Dismissal still applies until this page is reloaded.
            }
            setDismissed(true);
          }}
        >
          다시 보지 않기
        </button>
      </div>
    </div>
  );
};
